<template>
  <vs-popup class="rm-price-details-popup"
            id="popup"
            :title="'RM PRICE DETAILS - ' + priceDetails.company_product_name"
            @close="onClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">
          <vx-card>
            <div class="vx-row mb-8">
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="quantity" name="quantity" :rules="'required|moq:' + ((priceDetails.raw_material_commercial && priceDetails.raw_material_commercial.min_order_quantity) || 0) + '|maxoq:' + ((priceDetails.raw_material_commercial && priceDetails.raw_material_commercial.max_order_quantity) || '')" v-slot="{ errors }">
                  <small class="label">Quantity needed ({{ priceDetails.raw_material_unit }})</small>
                  <vs-input  size="large" v-on:input="onTypeQuantity" v-model="createForm.quantity"  name="quantity" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                  <small class="label">Unit best price</small>
                  <vx-input-group class="">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>{{ priceDetails.fx_code }}</span>
                      </div>
                    </template>
                    <vs-input size="large" readonly v-model="createForm.price"   name="price" class=" required" label=""/>
                  </vx-input-group>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                  <small class="label">Total best price</small>
                  <vx-input-group class="">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>{{ priceDetails.fx_code }}</span>
                      </div>
                    </template>
                    <vs-input size="large" readonly v-model="createForm.total"   name="price" class=" required" label=""/>
                  </vx-input-group>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <small class="label">&nbsp</small>
                <vs-button color="warning" button="submit" size="large" class="w-full">Add</vs-button>
              </div>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">

            </div>

            <div class="vx-row">
              <div class="vx-col lg:w-1/2 w-full">
                <vs-table :data="[]" noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="font-semibold">Company Prod Code</vs-td>
                      <vs-td>{{ priceDetails.category ? priceDetails.category.prefix : ''}}- {{priceDetails.company_product_code || ''}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Company Prod Name</vs-td>
                      <vs-td>{{priceDetails.company_product_name}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Supplier Prod Code</vs-td>
                      <vs-td>{{priceDetails.supplier_product_code}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Supplier Prod Name</vs-td>
                      <vs-td>{{priceDetails.supplier_product_name}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <div class="vx-col lg:w-1/2 w-full">
                <vs-table :data="[]" noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="font-semibold">Supplier</vs-td>
                      <vs-td>{{priceDetails.supplier}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Country</vs-td>
                      <vs-td>
                        <span v-for="(country, index) in priceDetails.country_processing" :key="index">
                          {{ country.name }},
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Alternative Chemical Name</vs-td>
                      <vs-td>{{priceDetails.alternative_chemical_name}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold"></vs-td>
                      <vs-td></vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vx-card>



          <vx-card class="mt-4">
            <div class="vx-row mb-3 mt-4" v-if="priceDetails.raw_material_commercial.is_contract_volume_price_tiers && calculateDisplayPriceSection() === 2">
              <div class="vx-col md:w-full w-full md:mb-0">
                <vs-table stripe :data="priceDetails.raw_material_commercial.contract_prices_tier">
                  <template slot="header">
                    <h5 class="text-opacity-10">Contract Price Volume Tiers</h5>
                  </template>
                  <template slot="thead">
                    <vs-th>MIN ORDER QTY</vs-th>
                    <vs-th>MAX ORDER QTY</vs-th>
                    <vs-th>PRICE PER UNIT (GBP)</vs-th>
                    <vs-th v-if="!__isCurrencyGbp(priceDetails.fx_code)">PRICE PER UNIT ({{priceDetails.fx_code}})</vs-th>
                    <vs-th>DELIVERY TERMS (Days)</vs-th>
                    <vs-th>PAYMENT TERMS (Days)</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                      <vs-td :data="data[indextr].min_order_quantity">
                        {{ data[indextr].min_order_quantity }}
                      </vs-td>

                      <vs-td :data="data[indextr].max_order_quantity">
                        {{ data[indextr].max_order_quantity }}
                      </vs-td>

                      <vs-td>
                        {{ Number(data[indextr].price_per_unit / priceDetails.fx_rate).toFixed(2) }}
                      </vs-td>

                      <vs-td v-if="!__isCurrencyGbp(priceDetails.fx_code)">
                        {{ Number(data[indextr].price_per_unit).toFixed(2) }}
                      </vs-td>

                      <vs-td>
                        {{ data[indextr].delivery_terms }}
                      </vs-td>

                      <vs-td>
                        {{ data[indextr] ? data[indextr].payment_terms : 'N/A' }}
                      </vs-td>
                    </vs-tr>
                  </template>

                </vs-table>
              </div>
            </div>

            <div class="vx-row mb-3 mt-4" v-if="priceDetails.raw_material_commercial.is_volume_price_tiers && calculateDisplayPriceSection() === 4">
              <div class="vx-col md:w-full w-full md:mb-0">
                <vs-table stripe :data="priceDetails.raw_material_commercial.prices_tier">
                  <template slot="header">
                    <h5>Price Volume Tiers</h5>
                  </template>
                  <template slot="thead">
                    <vs-th>MIN ORDER QTY</vs-th>
                    <vs-th>MAX ORDER QTY</vs-th>
                    <vs-th>PRICE PER UNIT (GBP)</vs-th>
                    <vs-th v-if="!__isCurrencyGbp(priceDetails.fx_code)">PRICE PER UNIT ({{priceDetails.fx_code}})</vs-th>
                    <vs-th>DELIVERY TERMS (Days)</vs-th>
                    <vs-th>PAYMENT TERMS (Days)</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                      <vs-td :data="data[indextr].min_order_quantity">
                        {{ data[indextr].min_order_quantity }}
                      </vs-td>
                      <vs-td :data="data[indextr].max_order_quantity">
                        {{ data[indextr].max_order_quantity }}
                      </vs-td>
                      <vs-td>
                        {{ Number(data[indextr].price_per_unit / priceDetails.fx_rate).toFixed(2) }}
                      </vs-td>
                      <vs-td v-if="!__isCurrencyGbp(priceDetails.fx_code)">
                        {{ Number(data[indextr].price_per_unit).toFixed(2) }}
                      </vs-td>
                      <vs-td>
                        {{ data[indextr].delivery_terms }}
                      </vs-td>
                      <vs-td>
                        {{ data[indextr] ? data[indextr].payment_terms : 'N/A' }}
                      </vs-td>
                    </vs-tr>
                  </template>

                </vs-table>
              </div>
            </div>

            <div class="vx-row mt-4">
              <div v-if="calculateDisplayPriceSection() === 3" class="vx-col lg:w-1/2 w-full">
                <vs-table :data="[]" noDataText="">
                  <template slot="header">
                    <h5 class="text-opacity-10">Volume Prices</h5>
                  </template>
                  <template>
                    <vs-tr>
                      <vs-td class="font-semibold">Payment Terms ( Days )</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.prices ?
                        priceDetails.raw_material_commercial.prices.payment_terms : 'N/A'}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Delivery Terms ( Days )</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.prices ?
                        priceDetails.raw_material_commercial.prices.delivery_terms : 'N/A'}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Price Per Unit ( GBP )</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.prices ?
                        Number(priceDetails.raw_material_commercial.prices.price_per_unit / priceDetails.fx_rate).toFixed(2) : 'N/A'}}</vs-td>
                    </vs-tr>
                    <vs-tr v-if="!__isCurrencyGbp(priceDetails.fx_code)">
                      <vs-td class="font-semibold">Price Per Unit ( {{ priceDetails.fx_code }} )</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.prices ?
                        Number(priceDetails.raw_material_commercial.prices.price_per_unit).toFixed(2) : 'N/A'}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <div class="vx-col lg:w-1/2 w-full" v-if="calculateDisplayPriceSection() === 1">
                <vs-table :data="[]" noDataText="">
                  <template slot="header">
                    <h5 class="text-opacity-10">Contract Prices</h5>
                  </template>
                  <template>
                    <vs-tr>
                      <vs-td class="font-semibold">Payment Terms ( Days )</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.contract_prices ?
                        priceDetails.raw_material_commercial.contract_prices.payment_terms : 'N/A'}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Delivery Terms ( Days )</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.contract_prices ?
                        priceDetails.raw_material_commercial.contract_prices.delivery_terms : 'N/A'}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Price Per Unit ( GBP )</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.contract_prices ?
                        Number(priceDetails.raw_material_commercial.contract_prices.price_per_unit / priceDetails.fx_rate).toFixed(2) : 'N/A'}}</vs-td>
                    </vs-tr>
                    <vs-tr v-if="!__isCurrencyGbp(priceDetails.fx_code)">
                      <vs-td class="font-semibold">Price Per Unit ({{ priceDetails.fx_code }})</vs-td>
                      <vs-td>{{priceDetails.raw_material_commercial.contract_prices ?
                        Number(priceDetails.raw_material_commercial.contract_prices.price_per_unit).toFixed(2) : 'N/A'}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

            <div class="vx-row mt-4">
              <div class="vx-col w-full">
                <vs-table
                  :data="priceDetails.similar_raw_materials || []"
                  sort
                  class="table-dark-inverted table-auto vs-con-loading__container">
                  <template slot="header">
                    <h5>
                      Alternative Products
                    </h5>
                  </template>
                  <template slot="thead">
                    <vs-th sort-key="company_product_code">ITS CODE</vs-th>
                    <vs-th sort-key="company_product_name">ITS NAME</vs-th>
                    <vs-th>SUPPLIER</vs-th>
                    <vs-th>MOQ</vs-th>
                    <vs-th>PRICE (GBP)</vs-th>
                    <vs-th>OFFER REASON</vs-th>
                    <vs-th>RM OFFER EXP</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :state="!!tr.is_blink ? 'success' : ''" :key="indextr" v-for="(tr, indextr) in data">


                      <vs-td :data="data[indextr].company_product_code">
                        {{ data[indextr].company_product_code || '-'}}
                      </vs-td>

                      <vs-td :data="data[indextr].company_product_name">
                        {{ data[indextr].company_product_name || '-'}}
                      </vs-td>

                      <vs-td :data="data[indextr].supplier">
                        {{data[indextr].supplier || '-'}}
                      </vs-td>

                      <vs-td :data="data[indextr].min_order_quantity">
                        {{ data[indextr].min_order_quantity || '-' }}
                      </vs-td>

                      <vs-td :data="data[indextr].gbp_price">
                        {{ data[indextr].gbp_price || '-' }}
                      </vs-td>

                      <vs-td :data="data[indextr].reason_for_offer">
                        {{offerReasonFactory(data[indextr].reason_for_offer)}}
                      </vs-td>

                      <vs-td :data="data[indextr].short_shelf_life_expiry">
                        {{ data[indextr].short_shelf_life_expiry || '-' }}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vx-card>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const InventoryRepository = RepositoryFactory.get('inventory')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {
        quantity: '',
        price: '',
        total: ''
      },
      displaySectionNumber: '',
      priceDetails: {
        raw_material_commercial: {
          is_contract_volume_price_tiers : false,
          is_volume_price_tiers: false,
          is_contracted: false,
          prices_tier: [],
          contract_prices_tier: []
        },
        similar_raw_materials: []
      }
    }
  }

export default {
  name: 'ShowRmPricePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, qty) {
      try {
        await Object.assign(this.$data, initialState())
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
        this.id = id
        await this.getPriceDetails()
        if (!!qty && Number(qty) > 0) {
          this.createForm.quantity = qty
          this.onTypeQuantity()
        }
        // await this.calculateDisplayPriceSection()

      } catch (error) {
        this.open = false;
      }
    },
    onClose() {
      this.open = false
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      if (this.$route.query.open || this.$route.query.qty) {
        this.$router.replace({ path: this.$route.path, query: { step: this.$route.query.step || 1 } }).catch(() => {})
      }
    },
    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
         const payload = {
           supplier_raw_material_id: this.priceDetails.id,
           category: this.priceDetails.category.prefix,
           supplier: this.priceDetails.supplier,
           company_product_code: this.priceDetails.company_product_code,
           company_product_name: this.priceDetails.company_product_name,
           supplier_product_code: this.priceDetails.supplier_product_code,
           supplier_product_name: this.priceDetails.supplier_product_name,
           quantity: this.createForm.quantity,
           price: (Number(this.createForm.price)).toFixed(2),
           currency_code: this.priceDetails.fx_code,
           gbp_price: (Number(this.createForm.price / this.priceDetails.fx_rate)).toFixed(2),
         }
         await InventoryRepository.addRmToCart(payload)
         this.showSuccessMessage('Raw Material add to the cart')
         this.open = false;
         if (this.$route.query.open || this.$route.query.qty) {
           this.$router.replace({ path: this.$route.path, query: { step: this.$route.query.step || 1 } }).catch(() => {})
         }
         await vue.$parent.onlyRefreshData()
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async getPriceDetails() {
      const vue = this
      this.$vs.loading()
      try {
        const {data} = await InventoryRepository.getRawMaterialPrice(this.id)
        this.priceDetails =  data.data
        if (!!this.priceDetails && !!this.priceDetails.raw_material_commercial && !!this.priceDetails.raw_material_commercial.id) {
          this.priceDetails.similar_raw_materials = (data.data.similar_raw_materials || []).map((m) => {m.is_blink = false; return m;})
          await this.calculateDisplayPriceSection()
          vue.open = true;
        } else {
          await vue.$parent.openAlert('danger')
        }

      } catch (e) {
        vue.open = false
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    onTypeQuantity() {
      const total = (Number(this.calculatePrice)).toFixed(2)
      if(total >= 0) {
        this.createForm.total = total
      } else {
        this.createForm.total = '0.00'
      }
    },
    calculateDisplayPriceSection() {
      const raw_material_commercial = this.priceDetails ? this.priceDetails.raw_material_commercial : null
      if (!raw_material_commercial) return ''
      if (raw_material_commercial.is_contracted) {
        if (!raw_material_commercial.is_contract_volume_price_tiers) {
          return 1;
        }
        return 2;
      } else {
        if (!raw_material_commercial.is_volume_price_tiers) {
          return 3;
        }
        return 4;
      }
    },
    offerReasonFactory(reason) {
      switch (reason) {
        case 'Sale':
          return 'Sale';
        case 'Short_Shelf_Life':
          return 'Short Shelf Life';
        case 'Over_Stock':
          return 'Over Stock';
        default:
          return 'N/A'
      }
    }
  },
  computed: {
    calculatePrice: function () {
      const raw_material_commercial = this.priceDetails ? this.priceDetails.raw_material_commercial : null
      if (!raw_material_commercial) return 0
      const quantity = Number(this.createForm.quantity)

      if (raw_material_commercial.is_contracted) {
        if (!raw_material_commercial.is_contract_volume_price_tiers) {
          const unitPrice = (raw_material_commercial.contract_prices && raw_material_commercial.contract_prices.price_per_unit) ? Number(raw_material_commercial.contract_prices.price_per_unit) : 0
          this.createForm.price = unitPrice.toFixed(2)
          return unitPrice * quantity
        }
        let price = 0;
        if (Array.isArray(raw_material_commercial.contract_prices_tier)) {
          raw_material_commercial.contract_prices_tier.forEach((item) => {
            const max = Number(item.max_order_quantity)
            const min = Number(item.min_order_quantity)
            if(max >= quantity && quantity >= min) {
              this.createForm.price = (Number(item.price_per_unit || 0)).toFixed(2)
              price = Number(item.price_per_unit || 0) * quantity
            }
          })
        }
        return price
      } else {
        if (!raw_material_commercial.is_volume_price_tiers) {
          const unitPrice = (raw_material_commercial.prices && raw_material_commercial.prices.price_per_unit) ? Number(raw_material_commercial.prices.price_per_unit) : 0
          this.createForm.price = unitPrice.toFixed(2)
          return unitPrice * quantity
        }
        let price = 0;
        if (Array.isArray(raw_material_commercial.prices_tier)) {
          raw_material_commercial.prices_tier.forEach((item) => {
            const max = Number(item.max_order_quantity)
            const min = Number(item.min_order_quantity)
            if(max >= quantity && quantity >= min) {
              this.createForm.price = (Number(item.price_per_unit || 0)).toFixed(2)
              price = Number(item.price_per_unit || 0) * quantity
            }
          })
        }
        return price
      }
    }
  },
  components: {
    'v-select': vSelect,
  },
  watch: {
    createForm: {
      deep: true,
      handler() {
        if (this.priceDetails.similar_raw_materials && this.priceDetails.similar_raw_materials.length > 0) {
          this.priceDetails.similar_raw_materials = this.priceDetails.similar_raw_materials.map((n) => {
            if(Number(n.price) <= Number(this.createForm.price)) {
              n.is_blink = true
            } else {
              n.is_blink = false
            }
            return n
          })
        }
      }
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .rm-price-details-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }


</style>
